
import { Component, Vue } from 'nuxt-property-decorator'
import { Articolo } from '~/types/models/Articolo'
import meta from '@/helpers/meta'

@Component
export default class ArticoliPage extends Vue {
  public items: Articolo[] = []
  public pagination!: any

  public head() {
    return meta(
      'News ed Eventi',
      "News ed eventi organizzati dall'Associazione astagiudiziaria.com",
      this.$config.siteUrl + 'img/logo.png',
      this.$config.siteUrl + 'news-eventi'
    )
  }

  async fetch() {
    const { data } = await this.$axios.get('articoli?attivo=1')
    this.items = data.items
    this.pagination = data.pagination
  }

  fetchOnServer() {
    return true
  }

  public getImage(item: Articolo) {
    if (!item?.assets?.length) {
      return '/img/blog-3.jpg'
    }
    const image = item.assets.find(
      (asset) => asset.assetableField === 'mainImage'
    )
    if (!image) {
      return '/img/blog-3.jpg'
    }
    return this.$config.cdnEndpoint + '512/' + image.originalName
  }
}
